import React, { useState, useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const MapLocationPicker = ({ location, setLocation }) => {
    const [lat, setLat] = useState(null);
    const [long, setLong] = useState(null);
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);

    useEffect(() => {
        const initializeMap = (initialLat, initialLong) => {
            if (mapInstanceRef.current) return;

            const customIcon = L.icon({
                iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
                iconSize: [30, 50], // Adjust width (50) and height (60)
                iconAnchor: [25, 60], // Adjust the anchor point for the new size
                popupAnchor: [0, -40],
            });

            mapInstanceRef.current = L.map(mapRef.current).setView([initialLat, initialLong], 13);

            L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {}).addTo(mapInstanceRef.current);
            const marker = L.marker([initialLat, initialLong], { icon: customIcon, draggable: true }).addTo(mapInstanceRef.current);
            marker.bindPopup("You are here").openPopup();

            marker.on("dragend", (event) => {
                const newLatLng = event.target.getLatLng();
                setLat(newLatLng.lat);
                setLong(newLatLng.lng);
                setLocation({ lat: newLatLng.lat, long: newLatLng.lng })
            });

            setLat(initialLat);
            setLong(initialLong);
            setLocation({ lat: initialLat, long: initialLong })
        };
        if (location && location.lat && location.long) {
            initializeMap(location.lat, location.long);
        } else {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        initializeMap(position.coords.latitude, position.coords.longitude);
                    },
                    (error) => {
                        console.error("Error getting geolocation:", error);
                        initializeMap(51.5074, -0.1278);
                    }
                );
            } else {
                alert("Geolocation is not supported by this browser.");
                initializeMap(51.5074, -0.1278);
            }
        }

        return () => {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
        };
    }, []);

    return (
        <div className="w-full h-full bg-gray-200 rounded-lg shadow-lg">
            <div ref={mapRef} className="w-full h-full rounded-lg"></div>
        </div>
    );
};

export default MapLocationPicker;
